'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/spin/style/css.js
// module id = WMEp
// module chunks = 0